import React from 'react';
import { Box, Typography } from '@mui/material';

import { useGetMyDebatesQuery } from 'redux/api/debate.api';
import Card from 'components/Card/Card';
import SkeletonCardList from 'components/Skeletons/CardSkeleton/SkeletonCardList/SkeletonCardList';
import { IDebateData } from 'shared/types/debates.interface';
import { ECardTypes } from 'shared/types/card.interface';
import { PAGE_PLACEHOLDERS_DATA } from 'shared/constants/no-content-constants';
import { CardsContainer } from 'components/Card/CardsContainer/CardsContainer';

export const MyDebates: React.FunctionComponent<any> = () => {
  const { data: myDebates = [], isLoading } = useGetMyDebatesQuery(undefined, {
    skip: window.location.pathname !== '/my-debates',
    pollingInterval: 1000,
    refetchOnMountOrArgChange: true,
  });

  return (
    <CardsContainer>
      {isLoading ? (
        <SkeletonCardList />
      ) : myDebates && myDebates.length ? (
        myDebates.map((debate: IDebateData) => (
          <Card
            cardInfo={debate.challenge}
            key={debate.id}
            type={ECardTypes.Debate}
            debate={debate}
          />
        ))
      ) : (
        <Box sx={{ width: '100%', textAlign: 'center' }}>
          <Typography variant="body1" color="primary.main">
            {PAGE_PLACEHOLDERS_DATA.myDebates}
          </Typography>
        </Box>
      )}
    </CardsContainer>
  );
};

export default MyDebates;
